<template>
    <v-container fluid>
        <v-layout row justify-center>

            <v-card class="v-sheet theme--light">
                <v-card-title>
                    <div style="padding: 24px 24px 0 24px">
                        <span class="headline">{{$t("Update Password")}}</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md style="padding-top: 0px;">

                        <v-alert outline style="text-align: left;" class="mb-3" :value="alert.visible" :type="alert.type" >
                            {{alert.text}}
                        </v-alert>

                        <div id="recover-password-form" v-show="showForm">
                            <div>{{$t("Fill the form with your new password to update it")}}</div>
                            <v-form>
                                <v-text-field prepend-icon="person" name="recoverPasswordToken" type="text" v-model="recoverPasswordToken" v-show="false"></v-text-field>
                                <v-text-field prepend-icon="email" name="securityToken" type="text" v-model="securityToken" v-show="false"></v-text-field>

                                <v-text-field prepend-icon="lock" name="password" :label="$t('Password')" type="password" required v-model="password"></v-text-field>
                                <v-text-field prepend-icon="lock" name="passwordR" :label="$t('Repeat Password')" type="password" required v-model="passwordVal"></v-text-field>

                                <v-btn color="primary" dark @click="updatePassword()">{{$t('Update Password')}}</v-btn>

                            </v-form>
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import AuthRepository from "@/repositories/AuthRepository";

    import { VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert,VCard, VCardTitle, VCardText } from 'vuetify/lib'

    export default {
        name: "RecoverPassword",
        components: {
            VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert, VCard, VCardTitle, VCardText
        },
        data () {
            return {
                // Alert
                alert: {},
                recoverPasswordToken: '',
                securityToken: '',
                password: "",
                passwordVal: "",
                showForm: true
            }
        },
        methods: {
            updatePassword() {
                    if(this.password !== "" && this.password === this.passwordVal){
                        AuthRepository.recoverPasswordToken(this.password, this.recoverPasswordToken, this.securityToken)
                            .then((response) => {
                                if (response.data.status) {
                                    this.showForm = false;
                                    this.alertSuccess(response.data.message + " " + this.$t("You can now log in! You will be redirected in a few seconds..."));
                                    setTimeout( () => this.$router.push({ path: '/home'}), 3000);
                                } else {
                                    this.alertError(response.data.message);
                                }
                            }).catch((error) =>{
                                this.alertError(error.data.message);
                            });
                    }else{
                        if(this.password == ""){
                            this.alertError(this.$t('Please, fill de password field'));
                        }

                        if(this.password !== this.passwordVal){
                            this.alertError(this.$t('Please, enter the same password in both fields'));
                        }
                    }
            },
            alertSuccess(text) {
                this.alert = {
                    type: "success",
                    text: text,
                    visible: true
                }
            },
            alertError(text) {
                this.alert = {
                    type: "error",
                    text: text,
                    visible: true
                }
            }
        },
        beforeMount(){
             if (this.$route.params.recoverPasswordToken) {
                 this.recoverPasswordToken = this.$route.params.recoverPasswordToken;

                 if(this.$route.params.recoverPasswordToken){
                     this.securityToken = this.$route.params.securityToken;
                 }
            //     AuthRepository.verify(this.token)
            //         .then((response) => {
            //             if (response.data.error) {
            //                 this.alertSuccess(response.data.message + " You can now log in!");
            //             } else {
            //                 this.alertError(response.data.message);
            //             }
            //         }).catch((error) =>{
            //         this.alertError(error.data.message);
            //     });
            }
        }
    }
</script>

<style scoped>

</style>